import { CSSProperties } from 'react';

import { WebsiteStyle } from '@cineamo/api/models/website-configuration/WebsiteStyle.types';

/**
 * The colour layer of the page background: the configured background colour, or the gradient
 * between it and `backgroundColorGradient`.
 *
 * The value is only meaningful on a viewport-sized element — that is how the layouts paint it
 * (see `PageBackgroundColorLayer`), so the gradient maps onto the viewport rather than onto the
 * element. Anything reproducing the page background has to keep that geometry to get the same
 * pixels.
 */
export function getPageBackgroundStyle(style: WebsiteStyle | undefined): CSSProperties {
    return style?.backgroundColorGradient
        ? {
              background: `linear-gradient(var(--gradient-angle, 135deg), ${style.backgroundColor}, ${style.backgroundColorGradient})`
          }
        : {
              backgroundColor: style?.backgroundColor
          };
}
